module.exports = __webpack_public_path__ + "img/22.21e15d7a.jpg";